export default (notification: any) => {
  // console.log('FooBaz Event: ', notification);
};
